<template>
  <NuxtLink
    class="content"
    :to="routeLink.path"
    @click.capture="handleClickPath"
  >
    <Icon
      v-if="progress === -1"
      class="icon"
      :name="iconName"
      color="primary"
    />
    <ProgressCircle
      v-else
      :size="22"
      :stroke="3"
      :progress="progress"
      class="progress"
    ></ProgressCircle>
    <span class="label">
      <span class="text">{{ category.title }}</span>
      <Icon
        v-if="isTrialItem"
        class="icon-gift"
        size="2rem"
        name="fluent-emoji-flat:wrapped-gift"
      />
    </span>
    <span v-if="progress === 1" class="mark-out"> {{ scoreOn20 }} / 20 </span>
  </NuxtLink>
</template>
<script lang="ts" setup>
import type { CategorySchema } from '~/types/schema';
import { retrieveDeepFromCategoryExerciseIds } from '~/lib/category/exercises';
interface Props {
  category: CategorySchema;
}

const props = defineProps({
  category: null
});

const { progressions } = inject(INJECT_PROGRESSION_EXERCISES);

const progressionIds = computed(() =>
  retrieveDeepFromCategoryExerciseIds(props.category)
);

const { progress, scoreOn20 } = useExercisesChapterProgressions(
  progressions,
  progressionIds
);

const { handleClickPath, iconName, isTrialItem, routeLink } =
  await useCategoryLinkTryAndLock(props.category);
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  gap: var(--gap_n);
}
.icon {
  position: relative;
  z-index: 1;
  flex: 0 0 auto;
  transition: color 100ms $ease-out-quad 0ms;
  color: var(--color_secondary);
}
.progress {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
}

.label {
  display: inline-block;
  position: relative;
  z-index: 1;
  flex-grow: 3;
  padding: 1rem 0;
  transition: color 100ms $ease-in-out-quad 0ms;
  color: var(--color_neutral_500);
  text-align: left;
  @include font('n', '500');
  .icon-gift {
    margin-left: 0.6rem;
  }
  .text {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      z-index: 0;
      bottom: -0.5rem;
      left: 0;
      width: 100%;
      height: 0.5rem;
      transform: scaleX(0);
      transform-origin: 0%;
      transition: transform 300ms $ease-out-quad;
      background: var(--color_secondary);
    }
  }
}
.mark-out {
  @include font('m', '800');

  flex-shrink: 0;
  color: var(--color_secondary);
  font-style: italic;
}
a {
  &:hover,
  &:focus,
  &.active,
  &.disabled {
    .label {
      .text {
        color: var(--color_secondary);
        &::before {
          transform: scaleX(1);
        }
      }
    }
  }
}
</style>
